import AppLogo from "assets/images/logo-app.webp";
import { Button, BUTTON_VARIANT } from "components/UI/Button";
import { useTranslation } from "localization/localization";
import { HeaderProps } from "./Header.types";
import { HeaderSteps } from "./HeaderSteps";
import s from "./Header.module.scss";

export const Header = ({ currentStep, onNext, onBack, nextDisabled, nextLabel }: HeaderProps) => {
  const { t } = useTranslation();

  return (
    <header className={s.header}>
      <div className={s.logoBox}>
        <img src={AppLogo} alt="Cargo Load Optimizer" className={s.logo} />
        <p className={s.appName}>{t("Cargo Load Optimizer")}</p>
      </div>

      <HeaderSteps currentStep={currentStep} />

      <div className={s.btnBox}>
        {onBack ? (
          <Button type="button" variant={BUTTON_VARIANT.SECONDARY} onClick={onBack}>
            {t("Back")}
          </Button>
        ) : null}
        {onNext ? (
          <Button disabled={nextDisabled} onClick={onNext} className={s.nextButton}>
            {t(nextLabel ?? "Next step")}
          </Button>
        ) : null}
      </div>
    </header>
  );
};
